// extracted by mini-css-extract-plugin
export var cardTitle = "_ju-1";
export var commentBubble = "_ju-e";
export var commentForm = "_ju-a";
export var commentInput = "_ju-b";
export var commentLabel = "_ju-d";
export var commentPrompt = "_ju-9";
export var csatCard = "_ju-0";
export var feedbackSection = "_ju-7";
export var starDisabled = "_ju-6";
export var starEmpty = "_ju-5";
export var starFilled = "_ju-4";
export var starWrapper = "_ju-3";
export var starsContainer = "_ju-2";
export var submittedComment = "_ju-c";
export var thankYouText = "_ju-8";